import { useRef, useState } from "react";
import { INITIAL_MARKET_PRICE_SETTING } from "../const/marketPriceInitial"
import { DELIVERY_PRICE_ADDITION } from "../const/marketPriceCds";
import { postReadAPI, postRegisterAPI, postUpdateAPI } from "../../../http/api/MarketPriceSetting";

export const useMarketPriceSettingForm = () => {

  const [marketPriceSetting, setMarketPriceSetting] = useState(INITIAL_MARKET_PRICE_SETTING);
  const marketPriceIdRef = useRef(null);
  const originalSettingRef = useRef(null);

  /**
   * 市況価格表IDから設定を読み込む
   * @param marketPriceId 市況価格表ID
   */
  const loadFromMarketPriceId = async (marketPriceId) => {
    try {
      const settingRes = await postReadAPI({marketPriceId});
      setMarketPriceSetting(deformat(settingRes.setting));
      marketPriceIdRef.current = marketPriceId;
      originalSettingRef.current = settingRes.setting;
    } catch (e) {
      throw(e);
    }
  }

  /**
   * 項目値を変更する
   * @param propName 項目名
   * @param value 値
   */
  const changePropValue = (propName, value) => {
    setMarketPriceSetting((prev) => ({
      ...prev,
      [propName]: value
    }))
  }

  /**
   * 市況価格表を登録する
   * @returns 市況価格表ID
   */
  const register = async () => {
    try {
      return await postRegisterAPI({setting: format(marketPriceSetting)});
    } catch (e) {
      throw(e);
    }
  }

  /**
   * 市況価格表を更新する
   * @returns 市況価格表ID
   */
  const update = async () => {
    try {
      await postUpdateAPI({
        marketPriceId: marketPriceIdRef.current,
        setting: format(marketPriceSetting)
      });
      return marketPriceIdRef.current;
    } catch (e) {
      throw(e);
    }
  }

  /**
   * 設定変更前の販売原票名と同じかどうかを判定する
   */
  const hasSameNameAsOriginal = () => {
    return originalSettingRef?.current?.marketPriceName === marketPriceSetting.marketPriceName;
  }

  return {
    marketPriceSetting,
    loadFromMarketPriceId,
    changePropValue,
    register,
    update,
    hasSameNameAsOriginal
  }
}

/**
 * フォーム値をDB値に変換
 * @param {} settingInForm 
 * @returns DB値
 */
const format = (settingInForm) => {
  const result = { ...settingInForm };

  if (settingInForm.isUsingSellingPrice) {
    result.primePriceMarkUpRate = settingInForm.primePriceMarkUpRate / 100;
    result.sellingPriceMarkUpRate = settingInForm.sellingPriceMarkUpRate / 100;
  }

  if (settingInForm.deliveryPriceAdditionCd === DELIVERY_PRICE_ADDITION.PERCENT) {
    result.deliveryPriceAdditionAmount = settingInForm.deliveryPriceAdditionAmount / 100;
  }

  return result;
}

/**
 * DB値をフォーム値に変換
 * @param {*} settingFromDb 
 * @returns フォーム値
 */
const deformat = (settingFromDb) => {
  const result = { ...settingFromDb };

  if (settingFromDb.isUsingSellingPrice) {
    result.primePriceMarkUpRate = settingFromDb.primePriceMarkUpRate * 100;
    result.sellingPriceMarkUpRate = settingFromDb.sellingPriceMarkUpRate * 100;
  }

  if (settingFromDb.deliveryPriceAdditionCd === DELIVERY_PRICE_ADDITION.PERCENT) {
    result.deliveryPriceAdditionAmount = settingFromDb.deliveryPriceAdditionAmount * 100;
  }

  return result;
}